import Typography from '@mui/material/Typography';
import { node } from 'prop-types';
import React, { memo } from 'react';

const OverlineLabel = ({ children, ...rest }) => (
  <Typography variant="overline" color="textSecondary" {...rest}>
    {children}
  </Typography>
);

OverlineLabel.propTypes = {
  children: node.isRequired,
};

export default memo(OverlineLabel);
